import { ClientAction } from '@worknet/models';

import { toast } from './toasts';

export const processClientAction = (action: ClientAction) => {
  switch (action.action) {
    case 'navigate':
      if (window.document.referrer) {
        window.parent.postMessage(
          { type: 'navigate', url: action.url },
          new URL(window.document.referrer).origin
        );
      }
      break;
    case 'show_alert':
      toast({
        title: action.message,
        position: 'top-right',
        status: 'info',
        duration: 5000,
        isClosable: true,
      });
      break;
    case 'raise_event':
      if (window.document.referrer) {
        window.parent.postMessage(
          { type: 'raise_event', event_name: action.event_name },
          new URL(window.document.referrer).origin
        );
      }
      break;
    default:
      console.log('Processing Client Action:', action satisfies never);
      break;
  }
};
